import { Subject } from 'rxjs';
import { CacheDescrittori } from '../../core/models/cache-descrittori';
import { CtxBodyAbstract } from './ctx-body-abstract';
import { CtxMenuSezioni } from './ctx-menu-sezioni';
import { CtxMessage } from './ctx-message';
import { DescrittoreSezione } from './descrittore-sezione';
import { FascicoloFull } from './fascicolo/fascicolo-full';
import { StatoInserimento } from './stato-inserimento';

export class ConfigurationUtilServiceDto {
  msg: CtxMessage;
  ctxMenu: CtxMenuSezioni;
  descrittoriBody: DescrittoreSezione[];
  descrittoriCached: CacheDescrittori;
  descrittoriMap: { [id: string]: DescrittoreSezione };
  url: string;
  fascicolo: FascicoloFull;
  mandatoryNotCompiled: number;
  statoInserimento: StatoInserimento;
  _ctxMenuSezioni: Subject<CtxMenuSezioni>;
  _ctxBody: Subject<CtxBodyAbstract>;

  constructor(
    msg: CtxMessage,
    ctxMenu: CtxMenuSezioni,
    descrittoriBody: DescrittoreSezione[],
    descrittoriCached: CacheDescrittori,
    descrittoriMap: { [id: string]: DescrittoreSezione },
    url: string,
  ) {

    this.msg = msg;
    this.ctxMenu = ctxMenu;
    this.descrittoriBody = descrittoriBody;
    this.descrittoriCached = descrittoriCached;
    this.descrittoriMap = descrittoriMap;
    this.url = url;

  }
}
